/*
 * This query parameter is used to view talent agent modal after share the talent agent modal url.
 * url example: talent-agent?viewVerifiedUser=userId
 */
export const VIEW_VERIFIED_USER_QUERY_PARAM = 'viewVerifiedUser';
